<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container>
        <v-row>
          <v-col md="4" v-for="(setting, index) in this.settings" :key="index">
            <v-card elevation="0" class="p-3 h-100">
              <h2 class="text-primary">{{ setting.name }}</h2>
              <v-list flat>
                <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(meta, index2) in setting.items"
                    :key="index2"
                    :to="meta.href"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="meta.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import Navigations from "../../components/Navigations.vue";

export default {
  components: {
    Navigations,
  },

  data: () => ({
    breadcrumb: [
      {
        text: "Instellingen",
        disabled: true,
        href: "/settings",
      },
    ],
    settings: [
      {
        name: "Kyano Cards",
        items: [
          {
            name: "Abonnement beheren",
            href: "http://account.kyano.app/subscriptions",
          },
          {
            name: "Gebruikers",
            href: "http://account.kyano.app/subscriptions",
          },
          {
            name: "Upgraden",
            href: "http://account.kyano.app/subscriptions",
          },
          {
            name: "Opzeggen",
            href: "http://account.kyano.app/subscriptions",
          },
        ],
      },
    ],
  }),
};
</script>
<style>
.settings-container {
  padding: 10px;
  background-color: white;
}
.p-3 {
  padding: 15px;
}

.h-100 {
  height: 100%;
}
</style>
